<template>
  <a-modal
    v-model="isShow"
    :footer="null"
    width="1300px"
    @cancel="handleCancel"
  >
    <a-spin :spinning="visible && image.length === 0">
      <img style="width: 100%" :src="image">
    </a-spin>
  </a-modal>
</template>

<script>
export default {
  name: 'PreviewImage',
  props: {
    // 是否预览
    visible: {
      type: Boolean,
      default: false
    },

    // 预览图片地址
    image: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    // 预览关闭
    handleCancel() {
      // 通知父组件关闭
      this.$emit('close')
      // 清空预览的图片
      this.$emit('update:image', '')
    }
  }
}
</script>
